import React, { useId } from 'react';
import { SALONI_LOGO_CENTER, SALONI_LOGO_TEXT } from '../brand/saloniLogoMarkSpec';

const WREATH_SRC = `${process.env.PUBLIC_URL || ''}/saloni-logo.png`;

function logoTextStyle({ fontFamily, fontSize, fontWeight, letterSpacing }) {
  return {
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing: letterSpacing || undefined,
  };
}

/**
 * Default Saloni Designs brand mark — original floral wreath image with refreshed center text.
 */
export default function SaloniLogoMark({
  size = 160,
  className = '',
  title = 'Saloni Designs',
  'aria-hidden': ariaHidden,
}) {
  const uid = useId().replace(/:/g, '');
  const center = `saloni-center-${uid}`;
  const clip = `saloni-clip-${uid}`;
  const { script, serif } = SALONI_LOGO_TEXT;

  return (
    <svg
      className={`saloni-logo-mark${className ? ` ${className}` : ''}`}
      width={size}
      height={size}
      viewBox="0 0 200 200"
      role={ariaHidden ? undefined : 'img'}
      aria-label={ariaHidden ? undefined : title}
      aria-hidden={ariaHidden || undefined}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id={center} cx="50%" cy="42%" r="58%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#fff8f2" />
        </radialGradient>
        <clipPath id={clip}>
          <circle cx="100" cy="100" r="99" />
        </clipPath>
      </defs>

      <g clipPath={`url(#${clip})`}>
        <image href={WREATH_SRC} x="0" y="0" width="200" height="200" preserveAspectRatio="xMidYMid slice" />
        <circle cx="100" cy="100" r={SALONI_LOGO_CENTER.coverRadius} fill={`url(#${center})`} />
        <circle
          cx="100"
          cy="100"
          r={SALONI_LOGO_CENTER.ringRadius}
          fill="none"
          stroke={SALONI_LOGO_CENTER.ringStroke}
          strokeWidth="1.1"
          strokeDasharray={SALONI_LOGO_CENTER.ringDash}
          opacity="0.85"
        />
        <text
          x={script.x}
          y={script.y}
          textAnchor="middle"
          fill={script.fill}
          style={logoTextStyle(script)}
        >
          {script.content}
        </text>
        <text
          x={serif.x}
          y={serif.y}
          textAnchor="middle"
          fill={serif.fill}
          style={logoTextStyle(serif)}
        >
          {serif.content}
        </text>
      </g>
    </svg>
  );
}
